import { ListItem, makeStyles, useTheme } from '@rneui/themed'
import { font } from 'app/theme'
import { Notification } from 'notifications/types'
import { isDummyNotificationRoute } from 'notifications/utils'
import React from 'react'
import ParsedText, { ParsedTextProps } from 'react-native-parsed-text'

interface Props {
  notification: Notification
  onPressNotification: (notification: Notification) => void
  onLinkPress: (url: string) => void
  parsePatterns: ParsedTextProps['parse']
}
export function NotificationItem(props: Props) {
  const notification = props.notification
  const styles = useStyles(notification)
  const { theme } = useTheme()

  return (
    <ListItem
      containerStyle={styles.container}
      bottomDivider
      onPress={() => props.onPressNotification(notification)}
    >
      <ListItem.Content>
        <ListItem.Title style={[, styles.title]} selectable={false}>
          {notification.title}
        </ListItem.Title>
        <ListItem.Subtitle style={styles.description} selectable={false}>
          <ParsedText parse={props.parsePatterns}>
            {notification.message}
          </ParsedText>
        </ListItem.Subtitle>
        <ListItem.Subtitle style={styles.date} selectable={false}>
          {notification.createdAt}
        </ListItem.Subtitle>
      </ListItem.Content>
      {isDummyNotificationRoute(notification.route.name) ? null : (
        <ListItem.Chevron
          size={35}
          color={notification.read ? theme.colors.black : theme.colors.primary}
        />
      )}
    </ListItem>
  )
}

const useStyles = makeStyles((theme, notification: Notification) => ({
  container: {
    opacity: notification.read ? 0.6 : 1.0,
  },
  title: {
    marginBottom: 8,
    fontSize: 18,
    fontFamily: font.bold,
    color: notification.read ? theme.colors?.grey0 : theme.colors?.primary,
  },
  description: {
    marginBottom: 10,
    fontSize: 16,
    color: notification.read ? theme.colors?.grey1 : theme.colors?.grey0,
  },
  date: {
    color: '#9e9e9e',
    fontSize: 14,
  },
}))
